import { SET_VERIFY_EMAIL_CHANGE_FORM, SET_UUID } from './constants';

export const initialState = {
  data: {
    emailAddress: '',
  },
  form: {},
  uuid: '',
};

const verifyEmail = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_VERIFY_EMAIL_CHANGE_FORM:
      return {
        ...state,
        form: action.form,
        loaded: true,
      };
    case SET_UUID:
      return {
        ...state,
        uuid: payload,
      };
    default:
      return state;
  }
};

export default verifyEmail;
